import React from "react";
import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Chip,
  Container,
  Grid,
  Stack,
  Typography,
} from "@mui/material";
import Link from "next/link";
import SectionTitle from "./SectionTitle";
import { projects } from "./homeData";

export default function ProjectsSection() {
  return (
    <Box component="section" id="projects" py={10} bgcolor={(theme) => theme.palette.grey[50]}>
      <Container>
        <SectionTitle
          eyebrow="Selected work"
          title="Recent projects and experiments"
          subtitle="A snapshot of the products, prototypes, and systems I have been crafting lately."
        />
        <Grid container spacing={4}>
          {projects.map((project) => (
            <Grid item xs={12} md={4} key={project.title}>
              <Card
                sx={{
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  borderRadius: "18px",
                  border: "1px solid rgba(15, 23, 42, 0.08)",
                  boxShadow: "0 20px 40px rgba(15, 23, 42, 0.08)",
                  transition: "transform 0.3s ease, box-shadow 0.3s ease",
                  '&:hover': {
                    transform: "translateY(-8px)",
                    boxShadow: "0 28px 60px rgba(15, 23, 42, 0.16)",
                  },
                }}
              >
                <CardContent sx={{ flexGrow: 1 }}>
                  <Stack spacing={2}>
                    <Typography variant="h3" component="h3" sx={{ fontWeight: 600 }}>
                      {project.title}
                    </Typography>
                    <Typography variant="body1" color="text.secondary">
                      {project.description}
                    </Typography>
                    <Stack direction="row" flexWrap="wrap" gap={1}>
                      {project.stack.map((tech) => (
                        <Chip key={tech} label={tech} size="small" />
                      ))}
                    </Stack>
                  </Stack>
                </CardContent>
                <CardActions sx={{ px: 3, pb: 3 }}>
                  <Button
                    component={Link}
                    href={project.action.href}
                    target={project.action.href.startsWith("http") ? "_blank" : undefined}
                    rel={project.action.href.startsWith("http") ? "noopener noreferrer" : undefined}
                    variant="contained"
                    sx={{ borderRadius: "999px", fontWeight: 600 }}
                  >
                    {project.action.label}
                  </Button>
                </CardActions>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
